const url = 'https://kind-pink-anemone-tutu.cyclic.app/updateVisitor/63a34ae5c62742fc15327e89'

function visitorCount() {
    fetch( url, {
        method: 'PATCH',
    })
}

export default visitorCount